<script setup lang="ts">
  import { IconImage, Checkbox, InfoTooltip } from '@/shared/ui';
  import type { PermissionCategory, Position } from '@/entities/Permission';
  import { formatMemberAuditDateTime } from '@/pages/admin/lib';
  import InfoIcon from '@/shared/assets/icons/InfoIcon.svg';

  const props = defineProps<{
    category: PermissionCategory;
    position: Position;
    isExpanded: boolean;
    permissionIds: Set<number>;
    columnCount: number;
  }>();

  const emit = defineEmits<{
    (e: 'toggle-permission', positionId: number, permissionId: number): void;
    (e: 'toggle-expansion', positionId: number): void;
  }>();

  const handlePermissionToggle = (permissionId: number) => {
    emit('toggle-permission', props.position.id, permissionId);
  };
</script>

<template>
  <tr class="table-row-hover text-xs border-t">
    <td class="sticky left-0 z-10 w-[400px] bg-white-01 px-6 py-4">
      <div class="flex items-center gap-3">
        <span class="font-medium text-gray-900">{{ position.name }}</span>
        <span v-if="position.department" class="text-gray-05 text-xs">
          ({{ position.department }})
        </span>
      </div>
    </td>

    <td
      v-for="permission in category.permissions"
      :key="`${position.id}-${permission.id}`"
      class="px-6 py-4 text-center"
    >
      <Checkbox
        :id="`permission-${position.id}-${permission.id}`"
        :checked="permissionIds.has(permission.id)"
        @toggle="handlePermissionToggle(permission.id)"
      />
    </td>

    <td class="px-12 py-4 text-center text-gray-xx-02">
      <InfoTooltip
        title="Informações do cargo"
        :icon="InfoIcon"
        :created-at="formatMemberAuditDateTime(position.createdAt)"
        :created-by="position.creator?.name ?? '-'"
        :updated-at="formatMemberAuditDateTime(position.updatedAt)"
        :updated-by="position.updater?.name ?? '-'"
        placement="top"
      >
        <button type="button" class="flex items-center justify-center">
          <IconImage :src="InfoIcon" alt="Informações" class="w-5.5 h-5.5" />
        </button>
      </InfoTooltip>
    </td>
  </tr>
</template>
